import arrayEquals from "./arrayEquals";

export default function getEqualityComparer<T>(value: T): (a: NonNullable<T>, b: T | undefined | null) => boolean {
	if (value != null && typeof value === "object" && "equals" in value && typeof (value as any).equals === "function") {
		return (a: any, b: any) => (a as any).equals(b);
	}

	if (value instanceof Date) {
		return (a: any, b: any) => b != null && a.getTime() === b.getTime();
	}

	if (Array.isArray(value)) {
		return arrayEquals as unknown as (a: NonNullable<T>, b: T | undefined | null) => boolean;
	}

	return (a: any, b: any) => a === b;
}
